import api from "../helpers/api";
import { ToastChakra } from "../helpers/toast";


const baseURL = process.env.REACT_APP_API_URL;

const getConfiguraciones = async () => {
    const response = await api.get(`${baseURL}/configuraciones/listar`);
   // console.log('esto traigo en servicio reportes:', response.data);
    return response.data;  // Aquí obtienes el objeto con `data`
}

const updateConfiguraciones = async (data) => {
    console.log('data a enviar :', data);
    const response = await api.put(`${baseURL}/configuraciones/actualizar`, data, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
    ToastChakra('CONFIGURACIÓN ACTUALIZADA', 'La configuración se ha actualizado correctamente', 'success', 3000, 'bottom-right');
    return response.data;
  };
  


const configuracionesService = {
    getConfiguraciones,
    updateConfiguraciones
}
export default configuracionesService;
